import React from "react";
import cashAppImg from "../../../assets/cash-app-qr-code.jpeg";

export const MembersDescription = () => {
  return (
    <div className="table-of-contents" style={{ width: "85%", padding: "15px" }}>
      <h1>Members Description</h1>
      <strong>Members will start launching campaign 2020.</strong>
      <p>*Sales representatives can start ASAP! Their job is to recruit the members in all areas of cosmetology all over on a commission basis. All payments will be done on a monthly pay scale from the 26th of the month to the 25th to be paid the first week of the month. Pay scales are as follows:</p>
      <strong>During preliminary advertisement campaign</strong>
      <ul style={{ textAlign: "initial" }}>
        <li> $80.00 2yr membership: 25% of every member signed up at a 2yr membership. Sales Rep receives $20-$30 after 100 sales (memberships)</li>
        <li>$125.00 Lifetime Membership 25%: Sales Rep receives $31.25-$41.25 after 100 sales (memberships)</li>
      </ul>
      <strong>For complete client exposure during and after launching campaign Summer &amp; Winter months 2020</strong>
      <ul style={{ textAlign: "initial" }}>
        <li>For a 2yr membership, Sales Rep receives $43.75</li>
        <li>For lifetime membership, Sales Rep will receive $62.50.</li>
      </ul>
      <p>Commission cap will be $70 for 2 memberships. $90 for lifetime membership &amp; OFI will only require 19% of all services performed. Base fee will be $45 &amp; services performed.</p>
      <div>
        <strong>Send Membership Payments To Our CashApp</strong>
        <img src={cashAppImg} alt="cash-app" style={{ margin: "0 auto", height: "50%", width: "50%" }} />
      </div>
    </div>
  );
};
